'use client';
import { IconButton, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { trackEvent } from '../../../../../utils/trackEvent';
import { TabsProps } from './type';
import getRichTextSummary from '../../../../RichText/getRichTextSummary';
import RichText from '../../../../RichText';

const MobileTabs = ({ projects, selected, setSelected }: TabsProps) => {
  const section = projects[selected];
  const LENGTH = projects.length - 1;
  if (!section || !LENGTH) return;

  const onClick = (index: number) => {
    trackEvent('select_content', {
      content_type: 'general_interaction',
      placement: 'projectCarousel',
      item_id: getRichTextSummary(projects[index]?.title),
    });
    setSelected(index);
  };

  return (
    <Stack
      direction={'row'}
      spacing={2}
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <IconButton
        aria-label={'previous'}
        disabled={selected === 0}
        onClick={() => onClick(selected - 1)}
        sx={{
          border: '1px solid',
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <Stack
        key={section.id}
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <Typography color={'textPrimary'}>
          {`${selected + 1}`.padStart(2, '0')} /
          <Typography component={'span'} color={'textSecondary'}>
            {`${LENGTH + 1}`.padStart(2, '0')}
          </Typography>
        </Typography>
        <RichText withTypography color={'textPrimary'}>
          {section.title}
        </RichText>
      </Stack>
      <IconButton
        aria-label={'next'}
        disabled={selected === LENGTH}
        onClick={() => onClick(selected + 1)}
        sx={{
          border: '1px solid',
        }}
      >
        <ArrowForwardIcon />
      </IconButton>
    </Stack>
  );
};

export default MobileTabs;
